import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-system-spinner',
  templateUrl: './spinner.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class SpinnerComponent {
  /**
   * The size of the spinner in pixels.
   * @group Props
   */
  @Input() size = 24;

  /**
   * The color of the spinner.
   * @group Props
   */
  @Input() color = 'text-system-500';

  /**
   * Additional classes to apply to the spinner.
   * @group Props
   */
  @Input() class = '';

  /**
   * Show loading text.
   * @group Props
   */
  @Input() showLoadingText = true;
}
